export class UndatedDocumentError extends Error {
    constructor(message: string = "Erro! Não é possível associar documentos sem data de expiração obrigatória") {
        super(message)
        this.name = "UndatedDocumentError"
    }
}
